define('ItemAvailability.OrderActionsLine.View', [
    'Backbone',
    'underscore',
    '_itemavailability_order_actions_line.tpl'
], function ItemAvailabilityOrderActionsLineView(
    Backbone,
    jQuery,
    _,
    ItemAvailabilityViewTpl
) {
    'use strict';

    return Backbone.View.extend({

        template: ItemAvailabilityViewTpl,

        initialize: function initialize(options) {
            this.application = options.application;
            this.model = options.model;
        },

        getContext: function getContext() {
            return {
                showNotStockMessage: this.model.get('item').get('quantityavailable') === 0,
                showOverOrderStock: this.model.get('quantity') > this.model.get('item').get('quantityavailable'),
                quantityAvailability: this.model.get('item').get('quantityavailable')
            };
        }
    });
});
